export const MAX_LISTING_PHOTOS = 30;
export const MAX_LISTING_PHOTO_BYTES = 2 * 1024 * 1024;
export const LISTING_PHOTO_SIZE_ERROR = "Cropped photo exceeds 2 MiB. Choose another photo.";
